import {sprintf} from "sprintf-js";
import {date_to_time_str} from "../../../lib/time";

const PAYMENTS_STYLE_LUT = (selected_row) => {
  return [
    {
      pred: (row) => row % 2 === 0,
      style: {
        background: "#EEE",
      }
    },
    {
      pred: (row, col) =>
        row - 1 === selected_row && selected_row !== -1,
      style: {
        background: "#DDD",
      }
    },
    {
      pred: (row, col) => row === 0,
      style: {
        background: "#CCC",
      }
    },
    {
      pred: () => true,
      style: {
        border: "solid black 1px",
      }
    },
  ]
}

const ADMIN_STYLE_LUT = (selected_row) => {
  return   [
    {
      pred: (row, col) => Math.floor((row - 1)/2) % 2 === 0,
      style: {
        background: "#EEE",
      }
    },
    {
      pred: (row, col) =>
        row - 1 === selected_row && selected_row !== -1,
      style: {
        background: "#DDD",
      }
    },
    {
      pred: (row, col) => row === 0,
      style: {
        background: "#CCC",
      }
    },
    {
      pred: (row, col) => (row - 1) % 2 === 0,
      style: {
        borderTop: "solid black 1px",
      }
    },
    {
      pred: () => true,
      style: {
        padding: "0 0.5rem",
        borderLeft: "solid black 1px",
        borderRight: "solid black 1px",
      }
    },
    {
      pred: (row) => row === 0,
      style: {
        borderTop: "solid black 1px"
      },
    },
    {
      pred: (row, col, num_rows, num_cols) => row === num_rows - 1,
      style: {
        borderBottom: "solid black 1px",
      }
    },
    {
      pred: (row, col) => col === 7,
      style: {
        maxWidth: "10rem",
      }
    }
  ];
}

const EST_TIMEZONE = "America/New_York";

const dump_timestamp = time_sec => {

  const local_date = new Date(time_sec * 1000);
  // convert to EST timezone
  const est_date = new Date(local_date.toLocaleString('en-US', {
    timeZone: EST_TIMEZONE,
  }));

  return sprintf("%02d-%02d-%04d %s EST",
    est_date.getMonth() + 1, est_date.getDate(),
    est_date.getFullYear(), date_to_time_str(est_date));
}

export { ADMIN_STYLE_LUT, PAYMENTS_STYLE_LUT, dump_timestamp };
